import React from 'react';
import { MainRoute } from './infrastructure';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap-icons/font/bootstrap-icons.css';

const url = window.location.href;
const hostname = window.location.hostname;
const [, stage, , flag] = url.split('.');

if (hostname !== 'localhost' && stage !== 'dev') {
    console.log = function () {};
}

function App() {
    return <MainRoute />;
}

export default App;
